<template>
    <div class="container-fluid py-4">
        <div class="text-center"><h2 class="my-0">Dnote AI – Terms & Conditions</h2></div>

        <div class="d-block position-relative terms-content-container">
            
            <p>
                Please read these terms and conditions carefully before using our application.
            </p>

            <h2>1. Eligibility</h2>
            <p>
                Dnote AI is exclusively designed for use by churches, ministries, and faith-based organizations.
                By registering, you confirm that your organization operates within these domains and that you
                are authorized to act on its behalf.
            </p>

            <h2>2. Account Responsibility</h2>
            <p>
                You are responsible for maintaining the confidentiality of your login credentials. Any activity that
                occurs under your account is your responsibility, and Dnote AI will not be liable for unauthorized
                access due to your negligence.
            </p>

            <h2>3. Data Ownership</h2>
            <p>
                All data, including sermons, member records, schedules, and media uploaded by your
                organization, remains your property. Dnote AI does not claim ownership of your content but
                reserves the right to store, back up, and process it for service enhancement.
            </p>

            <h2>4. Use Restrictions</h2>
            <p>
                You agree not to use the application for:
            </p>
            <ul>
                <li>Any illegal or unauthorized purpose</li>
                <li>Spreading misinformation or hate speech</li>
                <li>Uploading copyrighted content without permission</li>
                <li>Sharing personal data without consent</li>
            </ul>
            <p>
                Violations may lead to account suspension or termination.
            </p>

            <h2>5. Privacy and Data Protection</h2>
            <p>
                We are committed to protecting your data. Dnote AI complies with applicable data protection
                laws and implements secure data storage and encrypted communication. Your data will not be
                shared with third parties without your consent.
            </p>

            <h2>6. Service Availability</h2>
            <p>
                While we strive to provide 24/7 access, Dnote AI may occasionally be unavailable due to
                maintenance or unexpected outages. We do not guarantee uninterrupted service and shall not
                be held liable for downtimes.
            </p>

            <h2>7. Subscription & Payments</h2>
            <p>
                Access to premium features may require a paid subscription. Fees, renewal terms, and billing
                cycles will be clearly outlined during sign-up. Non-payment may result in limited access or
                suspension of your account.
            </p>

            <h2>8. Modifications to the Service</h2>
            <p>
                Dnote AI reserves the right to modify or discontinue any part of the application, temporarily or
                permanently, with or without notice. We aim to improve your experience and will strive to
                communicate major changes in advance.
            </p>

            <h2>9. Termination of Use</h2>
            <p>
                You may deactivate your account at any time. Dnote AI also reserves the right to terminate or
                suspend your account for violations of these Terms, with or without prior notice.
            </p>

            <h2>10. Limitation of Liability</h2>
            <p>
                Dnote AI is not liable for any direct, indirect, or consequential damages resulting from the use or
                inability to use the service, including loss of data, service interruption, or system errors.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "TermsConditions",
    beforeMount(){
        this.$store.commit("toggleEveryDisplay", true);
        this.$store.commit("toggleHideConfig", true);
    },
    beforeUnmount() {
        this.$store.commit("toggleEveryDisplay", false);
        this.$store.commit("toggleHideConfig", false);
    },
}
</script>

<style scoped lang="scss">
/* Optional: Add some basic styling for better readability of the terms content */
.terms-content-container {
    padding: 20px;
    max-width: 800px; /* Adjust as needed */
    margin: 20px auto; /* Center the content and add some top/bottom margin */
    background-color: #f8f8f8; /* A light grey background for the content area */
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* Subtle shadow */
    line-height: 1.6;
    color: #333;
}

.terms-content-container h1 {
    font-size: 2em;
    margin-bottom: 20px;
    color: #2c3e50;
    text-align: center;
}

.terms-content-container h2 {
    font-size: 1.5em;
    margin-top: 30px;
    margin-bottom: 10px;
    color: #34495e;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
}

.terms-content-container p {
    margin-bottom: 10px;
}

.terms-content-container ul {
    list-style-type: disc;
    margin-left: 25px;
    margin-bottom: 10px;
}

.terms-content-container ul li {
    margin-bottom: 5px;
}
</style>